import * as ROUTES from '@/router/route-names'

export default [
  {
    // TODO: This below broke the breadcrumbs...
    // :accountId(a\d+) - account ids must be an "a" followed by digits
    path: '/:accountId/dashboard',
    name: ROUTES.DASHBOARD,
    // route level code-splitting
    // this generates a separate chunk (about.[dashboard].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/AccountDashboard.vue'),
  },
  {
    path: '/:accountId/renewal',
    name: ROUTES.RENEWAL_DASHBOARD,
    component: () => import('../views/DashboardUnderwriting.vue'),
  },
  {
    path: '/:accountId/claims-portal',
    name: ROUTES.NEW_CLAIM_PORTAL,
    component: () => import('../views/claims/ClaimsPortal.vue'),
  },
  {
    path: '/:accountId/claims-portal/create',
    name: ROUTES.CREATE_CLAIM_PORTAL,
    component: () => import('../views/claims/CreateClaim.vue'),
  },
  {
    path: '/:accountId/certificate-request',
    name: ROUTES.CERT_OF_INSURANCE_REQUEST,
    component: () => import('../views/certificates/CertificateRequest.vue'),
  },
  {
    path: '/:accountId/account',
    name: ROUTES.ACCOUNT,
    component: () => import('../views/account/AccountPage.vue'),
  },
  {
    path: '/:accountId/account/calendar',
    name: ROUTES.ACCOUNT_CALENDAR,
    component: () => import('../views/account/AccountCalendar.vue'),
  },
  {
    path: '/:accountId/account/notifications',
    name: ROUTES.ACCOUNT_NOTIFICATIONS,
    component: () => import('../views/account/AccountNotifications.vue'),
  },
  {
    path: '/:accountId/account/configuration',
    name: ROUTES.ACCOUNT_CONFIGURATION,
    component: () => import('../views/account/AccountConfiguration.vue'),
  },
  {
    path: '/:accountId/account/management',
    name: ROUTES.ACCOUNT_MANAGEMENT,
    component: () => import('../views/account/ManageAccount.vue'),
  },
  {
    path: '/:accountId/account/activity',
    name: ROUTES.ACCOUNT_ACTIVITY,
    component: () => import('../views/account/AccountActivity.vue'),
  },
  {
    path: '/:accountId/communications',
    name: ROUTES.COMMUNICATIONS,
    component: () => import('../views/advisor-request/CommunicationCenter.vue'),
  },
  {
    path: '/:accountId/communications/:requestId',
    name: ROUTES.COMMUNICATIONS_THREAD,
    component: () => import('../views/advisor-request/CommunicationThread'),
  },
  {
    path: '/:accountId/profile',
    name: ROUTES.COMPANY_PROFILE,
    component: () => import('../views/underwriting/CompanyProfile.vue'),
  },
  {
    path: '/:accountId/selection',
    name: ROUTES.COVERAGE_SELECTION,
    component: () => import('../views/underwriting/CoverageSelection.vue'),
  },
  {
    path: '/:accountId/coverage-summary',
    name: ROUTES.COVERAGE_SUMMARY,
    component: () => import('../views/underwriting/CoverageSummary.vue'),
  },
  {
    path: '/:accountId/schedules/:type/:tabId?',
    name: ROUTES.SCHEDULES,
    component: () => import('../views/underwriting/SchedulesMainWrapper.vue'),
  },
  {
    path: '/:accountId/schedules/:type',
    name: ROUTES.SCHEDULES_TYPED,
    component: () => import('../views/underwriting/SchedulesMainWrapper.vue'),
  },
  {
    path: '/:accountId/policy',
    name: ROUTES.POLICY_INFO,
    component: () => import(/* webpackChunkName: "uploads" */ '../views/underwriting/PolicyInfo.vue'),
  },
  {
    path: '/:accountId/applications',
    name: ROUTES.APPLICATIONS,
    component: () => import('../views/underwriting/applications/Applications.vue'),
  },
  {
    path: '/:accountId/applications/:frontEndFormId',
    name: ROUTES.APPLICATION_FORM,
    component: () => import('../views/applications/DigitalApplicationForm.vue'),
  },
  {
    path: '/:accountId/loss-runs',
    name: ROUTES.LOSS_RUNS,
    component: () => import(/* webpackChunkName: "uploads" */ '../views/underwriting/LossRuns.vue'),
  },
  {
    path: '/:accountId/experience',
    name: ROUTES.EXPERIENCE_MOD,
    component: () => import(/* webpackChunkName: "uploads" */ '../views/underwriting/ExperienceMod.vue'),
  },
  {
    path: '/:accountId/financials',
    name: ROUTES.FINANCIALS,
    component: () => import(/* webpackChunkName: "uploads" */ '../views/underwriting/Financials.vue'),
  },
  {
    path: '/:accountId/documents',
    name: ROUTES.UNDERWRITING_DOCUMENTS,
    component: () => import(/* webpackChunkName: "uploads" */ '../views/underwriting/UnderwritingDocuments.vue'),
  },
  {
    path: '/:accountId/submit-to-advisor',
    name: ROUTES.SUBMIT_TO_ACCOUNT_MANAGER,
    component: () => import('../views/underwriting/SubmitToAdvisor.vue'),
  },
  {
    path: '/:accountId/details',
    name: ROUTES.ACCOUNT_DETAILS,
    component: () => import('../views/account/AccountDetails.vue'),
  },
  // In reality this would not be in an account context
  {
    path: '/:accountId/insurica-dashboard',
    name: ROUTES.INSURICA_DASHBOARD,
    component: () => import('../views/insurica/Dashboard.vue'),
  },
  {
    path: '/:accountId/staging',
    name: ROUTES.ACCOUNT_STAGING,
    component: () => import('../views/dashboard/AccountStaging.vue'),
  },
  {
    path: '/:accountId/internal-quote-review',
    name: ROUTES.INTERNAL_QUOTE_REVIEW,
    component: () => import('../views/insurica/InternalQuoteReview.vue'),
  },
  {
    path: '/:accountId/subjectivities',
    name: ROUTES.SUBJECTIVITIES,
    component: () => import('../views/insurica/QuoteSubjectivities.vue'),
  },
  {
    path: '/:accountId/quote-review',
    name: ROUTES.QUOTE_REVIEW,
    component: () => import('../views/insurica/QuoteReview.vue'),
  },
  {
    path: '/:accountId/bind-decision',
    name: ROUTES.BIND_DECISION,
    component: () => import('../views/insurica/BindDecision.vue'),
  },
  {
    path: '/:accountId/policy-selection',
    name: ROUTES.POLICY_SELECTION,
    component: () => import('../views/insurica/PolicySelection.vue'),
  },
  {
    path: '/:accountId/payment',
    name: ROUTES.PAYMENT,
    component: () => import('../views/insurica/PaymentView.vue'),
  },
  {
    path: '/:accountId/alps-payment/:alpsPolicyId',
    name: ROUTES.ALPS_PAYMENT,
    component: () => import('../views/alps/AlpsPayment.vue'),
  },
  {
    path: '/:accountId/alps-payment-success',
    name: ROUTES.ALPS_PAYMENT_SUCCESS,
    component: () => import('../views/alps/AlpsPaymentSuccess.vue'),
  },
  {
    path: '/:accountId/billing-history',
    name: ROUTES.BILLING_HISTORY,
    component: () => import('../views/alps/BillingHistoryView.vue'),
  },
  {
    path: '/:accountId/update-firm',
    name: ROUTES.UPDATE_FIRM,
    component: () => import('../views/alps/UpdateFirmView.vue'),
  },

  {
    path: '/:accountId/certificate-holders',
    name: ROUTES.CERT_HOLDERS,
    component: () => import('../views/risk-management/CertOfInsurance.vue'),
  },
]
